import React, { useEffect, useState } from 'react'
import TempNav from './TempNav'
import './Home.css'
import About from './About'
import Resume from './Resume'
import Portfolio from './Portfolio'
import Contact from './Contact'

function Home() {

    const [currentPage, setCurrentPage] = useState(<About />);

    useEffect(() => {
        function renderActivePage() {
            const scanActivePage = document.getElementsByClassName("Active");

            Array.from(scanActivePage).forEach((element) => {
                if (element.classList.contains("About")) setCurrentPage(<About />);
                else if (element.classList.contains("Resume")) setCurrentPage(<Resume />);
                else if (element.classList.contains("Portfolio")) setCurrentPage(<Portfolio />);
                else if (element.classList.contains("Contact")) setCurrentPage(<Contact />);
                else setCurrentPage(<p>Page Not Found</p>);
                });
            }

            window.addEventListener("click", renderActivePage);
            window.addEventListener("load", renderActivePage);

            return () => {
                window.removeEventListener("click", renderActivePage);
                window.removeEventListener("load",renderActivePage);
            };
    }, []);

    return (
        <div id='Home-Container'>
            <TempNav/>
            <div id='Changeable-Part'>
                {currentPage}
            </div>
        </div>
    )
}

export default Home

